module.exports = __webpack_public_path__ + "img/t5.319a1153.png";